import React from 'react';
import styles from './MoreMarkets.module.scss';

const MoreMarkets = ({ event }) => {
    const { moreMarkets: marketsCount } = event;

    return (
        <td className={styles.moreMarkets}>
            <button className={styles.moreMarketsBtn}>
                <span>{marketsCount || 0}</span>
                <i className='icon-arrow-down' />
            </button>
        </td>
    );
};

export default MoreMarkets;
